
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { cleanAndTrimString } from '../helpers';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  private renderer: Renderer2;

  constructor(
    private title: Title,
    private meta: Meta,
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  /**
   * * Set page and  Open Graph title
   *
   * @param {string} content
   * @memberof SeoService
   */
  setTitle(content: string) {
    if (content) {
      content = cleanAndTrimString(content, 60);
    }

    this.title.setTitle(content);
    this.meta.updateTag({ property: 'og:title', content: content });
  }

  /**
   * Set page and Open Graph description
   *
   * @param {string} content
   * @memberof SeoService
   */
  setDescription(content: string) {
    if (content) {
      content = cleanAndTrimString(content, 160);
    }

    this.meta.updateTag({ name: 'description', content: content });
    this.meta.updateTag({ property: 'og:description', content: content });
  }

  /**
   * Set Open Graph image URL
   *
   * @param {string} image
   * @memberof SeoService
   */
  setImage(image: string) {
    this.meta.updateTag({ property: 'og:image', content: image });

    // Image (optional)
    // if (data['image']) {
    //   this.meta.updateTag({ property: 'og:image', content: data['image'] || defaultImage});
    // } else {
    //   this.meta.removeTag("property='og:image'")
    // }
  }

  /**
   * Set page keywords
   *
   * @param {string} keywords
   * @memberof SeoService
   */
  setKeywords(keywords: string) {
    this.meta.updateTag({ name: 'keywords', content: keywords });
  }

  /**
   * Set canonical URL for the page and  Open Graph URL
   *
   * @param {string} url
   * @memberof SeoService
   */
  setUrl(url: string) {
    const currentUrl = this.document.location.origin + this.document.location.pathname;
    this.meta.updateTag({ property: 'og:url', content: url || currentUrl });

    const canonicalLink = this.document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      this.renderer.setAttribute(
        canonicalLink,
        'href',
        url || currentUrl
      );
    }
  }

  /**
   * TODO: Add Google Structured Markup Data using JSON-LD format
   * https://developers.google.com/search/docs/appearance/structured-data/intro-structured-data
   *
   * @memberof SeoService
   */
  addStructuredData() {
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = `
    {
      "@context": "http://schema.org",
      "@type": "Organization",
      "name": "Your Angular App",
      "url": "https://your-angular-app.com",
      "logo": "https://your-angular-app.com/logo.png",
      "description": "Learn more about us at Your Angular App."
    }`;
    this.renderer.appendChild(document.head, script);
  }
}
